export default __webpack_public_path__ + "static/media/tel-icon.ce9930c5.svg";